var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{attrs:{"checked":_vm.value,"switch":"","disabled":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }